import React, { Component } from 'react';
import DropSelector from './../../../commons/DropSelector.js';
import Loader from './../../../commons/Loader.js';
import JobsOperationsApiHandler from './../JobsOperationsApiHandler.js';
import SortingSlot from './Commons/SortingSlot.js';
import SortingGeneration from './Commons/SortingGeneration.js';
import ErrorBox from './../../../commons/ErrorBox';


export default class SortingJobs extends Component {
	constructor(props) {
		super(props);
		this.state = {
			dates: [],
			selectedDate: null,
			sortingTypes: [],
			selectedSortingType: null,
			showFetchJobsLoader: false,
			slots: null,
			showSlots: true,
			generationData: null,
			error: null
		};
		//this.dateSelected = this.dateSelected.bind(this);
		//this.sortingTypeSelected = this.sortingTypeSelected.bind(this);
		//this.getSlotsData = this.getSlotsData.bind(this);
		//this.showGenerations = this.showGenerations.bind(this);
		//this.hideGenerations = this.hideGenerations.bind(this);
		//this.closeError = this.closeError.bind(this);
	}

	//<!---------------------------- Fetching Delivery Dates ----------------------------!>
	fetchDeliveryDates() {
		JobsOperationsApiHandler.fetchDeliveryDates()
			.then(resp => {
				this.setState({ dates: resp, selectedDate: resp[0] });
				this.dateSelected(resp[0]);
			}).catch(error => {

			}).finally(() => { })
	}

	//<!---------------------------- Fetching Sorting Types ----------------------------!>
	fetchSortingTypes() {
		JobsOperationsApiHandler.fetchSortingTypes()
			.then(resp => {
				this.setState({ sortingTypes: resp, selectedSortingType: resp[0] })
			}).catch(error => {

			}).finally(() => { })
	}


	//<!---------------------------- Fetching Slots After Date Selection ----------------------------!>
	dateSelected = (selectedDate) => {
		this.setState({ selectedDate: selectedDate, showFetchJobsLoader: true });
		JobsOperationsApiHandler.fetchSlotsForDate(selectedDate.deliveryDateInEpoch)
			//JobsOperationsApiHandler.fetchSlotsForDate()
			.then(resp => {
				this.setState({ slots: resp });
			}).catch(error => {
				this.setState({ error: error.error.error });
			}).finally(() => {
				this.setState({ showFetchJobsLoader: false });
			})
	}

	//<!---------------------------- Fetching Slots After Sorting Type Selection ----------------------------!>
	// When user will select the sorting type, System will again fetch the Slots with the delivery date already selected.
	sortingTypeSelected = (selectedSortingType) => {
		this.setState({ selectedSortingType: selectedSortingType });
		this.dateSelected(this.state.selectedDate);
	}

	//<!---------------------------- Showing Trips Generation Screen with the data coming from the backend ----------------------------!>
	showGenerations = (data) => {
		this.setState({ generationData: data });
		this.setState({ showSlots: false });
	}

	//<!---------------------------- Hinding Trips Generation Screen ----------------------------!>
	hideGenerations = () => {
		this.setState({ showSlots: true });
	}

	closeError = () => {
		this.setState({
			error: null
		})
	}

	//<!---------------------------- Rendering Data for Slots ----------------------------!>
	getSlotsData = () => {
		var slotsData;
		var slots = this.state.slots;
		if (slots) {
			if (slots.length === 0) {
				slotsData = (<div className="no-slots">No Slots Available</div>)
			} else {
				slotsData = slots.map((slot, index) => {
					return <SortingSlot slot={slot} key={index} sortingType={this.state.selectedSortingType} showGenerations={this.showGenerations} />
				})
			}
		}
		return slotsData;
	}

	componentWillMount() {
		this.fetchDeliveryDates();
		this.fetchSortingTypes();
	}

	render() {
		return (
			<div>
				{(this.state.showSlots) ?
					<div>
						<div className="putaway-header">
							<div className="row">
								<div className="col-xs-6 col-sm-8 col-md-9 no-padding-xs">
									<DropSelector options={this.state.sortingTypes} selected={this.state.selectedSortingType} value={'sortingTypeDescription'} classes={'pull-right'} selctionChange={this.sortingTypeSelected} type={'Sorting Type'} />
								</div>
								<div className="col-xs-6 col-sm-4 col-md-3 no-padding-xs">
									<div style={{ textAlign: 'right' }}>
										<DropSelector options={this.state.dates} selected={this.state.selectedDate} value={'deliveryDate'} classes={'pull-right'} selctionChange={this.dateSelected} type={'Delivery Date'} />
									</div>
								</div>
							</div>
						</div>
						{(this.state.slots && !this.state.showFetchJobsLoader) ?
							<div className="pickjobs-wrapper">
								<div className="pick-name-holder">
									{this.getSlotsData()}
								</div>
							</div>
							: null
						}
						{(this.state.showFetchJobsLoader) ?
							<Loader /> : null
						}
					</div>
					:
					<div>
						<SortingGeneration hideGenerations={this.hideGenerations} generationData={this.state.generationData} processType={this.state.selectedSortingType} />
					</div>
				}
				{(this.state.error) ?
					<ErrorBox errorText={this.state.error} closeError={this.closeError} /> : null
				}
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/screens/JobOperations/Components/SortingJobs.js